var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAttentionDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3V17C16 18.65 14.65 20 13 20H3C1.35 20 0 18.65 0 17V4C0 3.45 0.45 3 1 3C1.55 3 2 3.45 2 4V17C2 17.55 2.45 18 3 18H13C13.55 18 14 17.55 14 17V3C14 2.45 13.55 2 13 2H7C6.93 2 6.88 1.97 6.82 1.96C6.76 1.97 6.7 2 6.64 2C6.3 2 6.01 2.29 6.01 2.63V8C6.01 8.55 6.46 9 7.01 9C7.56 9 8.01 8.55 8.01 8V5C8.01 4.45 8.46 4 9.01 4C9.56 4 10.01 4.45 10.01 5V8C10.01 9.65 8.66 11 7.01 11C5.36 11 4.01 9.65 4.01 8V2.63C4.01 1.18 5.19 0 6.64 0C6.71 0 6.76 0.03 6.82 0.04C6.88 0.03 6.94 0 7 0H13C14.65 0 16 1.35 16 3Z",
    fill: "#585A5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttentionDetails);
export default __webpack_public_path__ + "static/media/icon_attention_details.c92e50966d945fea767c0516aecb23ef.svg";
export { ForwardRef as ReactComponent };